import React, { useState, useEffect } from 'react';
import { FormField, InlineAlert, Modal, TextAreaField } from './ui';
import api from '../../services/api';

const BeltFormDialog = ({ open, onClose, belt, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    color_code: '#000000',
    hierarchy_order: '',
    description: '',
    youtube_video_url: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setError('');
    if (belt) {
      setFormData({
        name: belt.name || '',
        color_code: belt.color_code || '#000000',
        hierarchy_order: belt.hierarchy_order || '',
        description: belt.description || '',
        youtube_video_url: belt.youtube_video_url || '',
      });
    } else {
      setFormData({
        name: '',
        color_code: '#000000',
        hierarchy_order: '',
        description: '',
        youtube_video_url: '',
      });
    }
  }, [open, belt]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const dataToSend = {
        ...formData,
        hierarchy_order: parseInt(formData.hierarchy_order, 10),
      };
      if (belt) {
        await api.put(`/admin/belts/${belt.id}`, dataToSend);
      } else {
        await api.post('/admin/belts', dataToSend);
      }
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error saving belt:', err);
      setError(err.response?.data?.message || 'Error al guardar el cinturón');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title={belt ? 'Editar cinturón' : 'Agregar cinturón'}
      onClose={submitting ? undefined : onClose}
      footer={
        <>
          <button type="button" className="btn-admin-secondary" onClick={onClose} disabled={submitting}>
            Cancelar
          </button>
          <button type="submit" form="belt-form" className="btn-admin" disabled={submitting}>
            {submitting ? 'Guardando…' : belt ? 'Guardar' : 'Crear'}
          </button>
        </>
      }
    >
      <form id="belt-form" className="space-y-4" onSubmit={handleSubmit}>
        {error && <InlineAlert tone="error">{error}</InlineAlert>}
        <FormField id="name" label="Nombre" value={formData.name} onChange={handleChange} required placeholder="Ej: Amarillo, 1° DAN" />
        <div>
          <label className="field-label" htmlFor="color_code">Color</label>
          <div className="flex items-center gap-3">
            <input
              id="color_picker"
              type="color"
              name="color_code"
              value={formData.color_code}
              onChange={handleChange}
              className="h-10 w-14 cursor-pointer rounded border border-line bg-surface"
            />
            <span
              className="h-10 w-10 rounded-full border-2 border-line"
              style={{ backgroundColor: formData.color_code }}
              aria-hidden="true"
            />
            <input
              id="color_code"
              name="color_code"
              className="field-input"
              value={formData.color_code}
              onChange={handleChange}
              placeholder="#000000"
            />
          </div>
        </div>
        <FormField
          id="hierarchy_order"
          label="Orden de jerarquía"
          type="number"
          value={formData.hierarchy_order}
          onChange={handleChange}
          required
        />
        <TextAreaField id="description" label="Descripción" value={formData.description} onChange={handleChange} />
        <FormField
          id="youtube_video_url"
          label="URL de video"
          value={formData.youtube_video_url}
          onChange={handleChange}
          placeholder="YouTube o Google Drive"
        />
      </form>
    </Modal>
  );
};

export default BeltFormDialog;
